import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@erp/ui";

import { AuthLayout } from "./auth-layout";

/**
 * An account is named by its user code and holds no address, so there is
 * nowhere to send a reset link. The page keeps its route — a bookmark should
 * not land on a 404 — and says who to ask instead of collecting an address it
 * cannot use.
 */
export function ForgotPasswordPage() {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>
            <h1>{t("auth.forgotPassword")}</h1>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p
            role="status"
            className="rounded-md border border-border bg-muted px-3 py-2 text-sm text-muted-foreground"
          >
            {t("auth.resetUnavailable")}
          </p>
        </CardContent>
        <CardFooter>
          <Link to="/login" className="text-sm text-primary underline-offset-4 hover:underline">
            {t("auth.backToLogin", "Back to sign in")}
          </Link>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
}
